import axios from 'axios';

// Constants.
import * as PayConnectedPackagesConstants from 'constants/PayConnectedPackagesConstants';
import * as ErrorConstants from 'constants/ErrorConstants';
import {
  LOAD_PAYMENT_METHODS_FAILURE,
  LOAD_PAYMENT_METHODS_REQUEST,
  LOAD_PAYMENT_METHODS_SUCCESS
} from "constants/PayConnectedPackagesConstants";

import { goToLogin } from "./AuthActions";

import { billingURL } from 'config';

function requestLoadPayConnectedPackages() {
  return {
    type: PayConnectedPackagesConstants.LOAD_PAY_CONNECTED_PACKAGES_REQUEST,
  };
}

function receiveLoadPayConnectedPackages(payConnectedPackages) {
  return {
    type: PayConnectedPackagesConstants.LOAD_PAY_CONNECTED_PACKAGES_SUCCESS,
    payConnectedPackages,
  };
}

function receiveLoadPayConnectedPackagesError(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    response,
  };
}

function requestLoadPaymentMethods() {
  return {
    type: PayConnectedPackagesConstants.LOAD_PAYMENT_METHODS_REQUEST,
  };
}

function requestLoadPaymentMethodsSuccess(paymentMethods) {
  return {
    type: PayConnectedPackagesConstants.LOAD_PAYMENT_METHODS_SUCCESS,
    payload: {
      paymentMethods
    },
  };
}

function requestLoadPaymentMethodsFailure(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    error: {
      response
    },
  };
}

export function loadPayConnectedPackages() {
  return (dispatch) => {
    dispatch(requestLoadPayConnectedPackages());
    axios({
      method: 'GET',
      url: '/api/v1/purchases/',
      baseURL: billingURL,
    })
      .then((response) => {
        const payConnectedPackages = response.data;
        dispatch(receiveLoadPayConnectedPackages(payConnectedPackages));
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(goToLogin());
          }
          else {
            dispatch(receiveLoadPayConnectedPackagesError(error.response));
            // dispatch(push({ pathname: '/error' }));
          }
        }
      });
  };
}

export function loadPaymentMethods() {
  return (dispatch) => {
    dispatch(requestLoadPaymentMethods());
    axios({
      method: 'GET',
      url: 'dashboard_api/v1/billing/payment_methods/',
    })
      .then((response) => {
        const paymentMethods = response.data;
        dispatch(requestLoadPaymentMethodsSuccess(paymentMethods.result.data));
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(goToLogin());
          }
          else {
            dispatch(requestLoadPaymentMethodsFailure(error.response));
            // dispatch(push({ pathname: '/error' }));
          }
        }
      });
  };
}

function requestCancelPayConnectedPackage() {
  return {
    type: PayConnectedPackagesConstants.CANCEL_PAY_CONNECTED_PACKAGE_REQUEST,
  };
}

function receiveCancelPayConnectedPackage() {
  return {
    type: PayConnectedPackagesConstants.CANCEL_PAY_CONNECTED_PACKAGE_SUCCESS,
  };
}

function receiveCancelPayConnectedPackageError(response) {
  return {
    type: PayConnectedPackagesConstants.CANCEL_PAY_CONNECTED_PACKAGE_FAILURE,
    response,
  };
}

export function cancelPayConnectedPackage(purchase_id) {
  return (dispatch) => {
    dispatch(requestCancelPayConnectedPackage());
    axios({
      method: 'POST',
      baseURL: billingURL,
      url: '/api/v1/stripe/subscription/cancel/',
      data: {
        purchase_id: purchase_id
      }
    })
      .then((response) => {
        dispatch(receiveCancelPayConnectedPackage());
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(goToLogin());
          }
          else {
            dispatch(receiveCancelPayConnectedPackageError(error.response.data));
            // dispatch(push({ pathname: '/error' }));
          }
        }
      });
  }
}
